<script lang="ts">
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"

  const { purpose } = $props<{ purpose: string }>()
  const previews = {
    announcement: {
      title: "WhatsApp zur Terminankündigung",
      body:
        "Guten Tag, KehrBlatt kontaktiert Sie im Auftrag von [Betriebsname]. " +
        "Für [Liegenschaftsadresse] steht ein Schornsteinfegertermin für Arbeiten vom Typ [Auftragstyp] an. " +
        "Vorgeschlagener Termin: [Datum] zwischen [Zeitfenster-Start] und [Zeitfenster-Ende] Uhr. " +
        "Bitte bestätigen Sie den Termin über den folgenden Link oder wählen Sie einen passenden Alternativtermin.",
    },
    reschedule: {
      title: "WhatsApp bei Terminverschiebung",
      body:
        "Guten Tag, KehrBlatt kontaktiert Sie im Auftrag von [Betriebsname]. " +
        "Der bisherige Termin entfällt. Für [Liegenschaftsadresse] wird ein neuer Schornsteinfegertermin " +
        "für Arbeiten vom Typ [Auftragstyp] benötigt. Neuer Terminvorschlag: [Datum] zwischen " +
        "[Zeitfenster-Start] und [Zeitfenster-Ende] Uhr. Bitte bestätigen Sie den neuen Termin über den " +
        "folgenden Link oder wählen Sie einen passenden Alternativtermin.",
    },
  }
  const preview = $derived(purpose === "reschedule" ? previews.reschedule : previews.announcement)
</script>

<section aria-label="WhatsApp-Vorlagen" class="whatsapp-section">
  <SectionTitle
    title="WhatsApp-Vorlagen"
    brightBackground={true}
    small={true}
    helpModalTextId="planningWhatsappTemplates"
  />
  <ActionBox label={preview.title}>
    <div class="whatsapp-preview" aria-readonly="true">
      <p>{preview.body}</p>
      <div class="whatsapp-actions" aria-label="WhatsApp-Buttons">
        <span>Termin vereinbaren</span><span>Ich bin nicht zuständig</span>
      </div>
    </div>
  </ActionBox>
</section>

<style>
  .whatsapp-section {
    display: grid;
    gap: 1rem;
    min-width: 0;
  }
  .whatsapp-preview {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    color: var(--text-invers-100);
    line-height: 1.45;
  }
  .whatsapp-preview p {
    margin: 0;
  }
  .whatsapp-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .whatsapp-actions span {
    border: 1px solid var(--text-invers-100);
    padding: 0.35rem 0.55rem;
    font-weight: 700;
    text-transform: uppercase;
  }
</style>
